import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { EStatusLoteEnum, StatusLoteMap } from "../enums/EStatusLoteEnum";
import { FormField } from "../../interfaces/FormField";
import { ITableProps } from "../components/table/ITableProps";
import { ActivatedRoute, Router } from "@angular/router";
import { EImportacaoType } from "../components/table/EImportacaoType";
import { HttpParams } from "@angular/common/http";
import {
  OrigemImportacao,
  OrigemImportacaoService,
} from "../utils/origem-importacao.service";
import { EStatusLoteFuncionarioEnum, StatusLoteFuncionarioMap } from "../../importacao-funcionario-lote/enums/EStatusLoteFuncionarioEnum";

interface ILote {
  loteId: number;
  nomeArquivo: string;
  status: EStatusLoteEnum;
  qtdProcessada: number;
  qtdProcessadasValidacao: number;
  totalRegistros: number;
  ultimaAtualizacao: Date;
}

@Component({ template: "" })
export default abstract class HistoricoImportacaoBaseComponent
  implements OnInit, OnDestroy
{
  public showStatus: boolean = true;
  public fileName = "";
  public total = 0;
  public imported = 0;
  public status: "success" | "processing" | "error" = null;
  public loteId: number;
  public enum: any = EStatusLoteEnum;
  public enumMap = StatusLoteMap;
  public filters: HttpParams = new HttpParams();
  public breadcrumbPath;

  public emitirCartao: string;
  public origemImportacao: OrigemImportacao;

  public abstract cargaFormFields: FormField[];
  public abstract tableColumns: Array<ITableProps>;

  public intervalId: any;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private origemService: OrigemImportacaoService,
    public importacaoType: EImportacaoType
  ) {}

  ngOnInit(): void {
    this.origemImportacao = this.origemService.getOrigemImportacao();
    this.emitirCartao = this.origemService.getEmitirCartao(
      this.origemImportacao
    );
    this.findImportacao();

    if (this.importacaoType === EImportacaoType.FUNCIONARIO) {
      this.enum = EStatusLoteFuncionarioEnum;
      this.enumMap = StatusLoteFuncionarioMap;
    }

    if (this.loteId) {
      this.breadcrumbPath = [
        { label: `Lote ID ${this.loteId}` },
        { label: "Importação" },
      ];
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.subscriptions.unsubscribe();
  }

  abstract findImportacao(): void;
  abstract navigate(): void;
  abstract filter(event): void;
  abstract action(): void;

  validarLotes(lotes: Array<ILote>) {
    if (lotes.length > 0) {
      const aberto = lotes.find(
        (lote) => lote.status === EStatusLoteEnum.ABERTO
      );

      let loteEscolhido: ILote;
      if (aberto) {
        loteEscolhido = aberto;
      } else {
        loteEscolhido = lotes.reduce((maisAntigo, loteAtual) => {
          return new Date(loteAtual.ultimaAtualizacao) <
            new Date(maisAntigo.ultimaAtualizacao)
            ? loteAtual
            : maisAntigo;
        }, lotes[0]);
      }

      let status;
      if (
        loteEscolhido.qtdProcessadasValidacao === loteEscolhido.totalRegistros
      ) {
        status = "success";
      } else {
        status = "processing";
      }

      this.fileName = loteEscolhido.nomeArquivo;
      this.total = loteEscolhido.totalRegistros;
      this.imported = loteEscolhido.qtdProcessadasValidacao;
      this.status = status;
      this.loteId = loteEscolhido.loteId;
    }
  }

  viewLote(lote: any) {
    let page = "";
    switch (EStatusLoteEnum[lote.status]) {
      case EStatusLoteEnum.CRIADO:
      case EStatusLoteEnum.EM_VALIDACAO:
      case EStatusLoteEnum.ERRO:
        page = "importar-arquivo";
        break;
      case EStatusLoteEnum.ABERTO:
        page = "validar-importacao";
        break;
      case EStatusLoteEnum.AGUARDANDO_PROCESSAMENTO:
      case EStatusLoteEnum.EM_PROCESSAMENTO:
      case EStatusLoteEnum.FINALIZADO:
      case EStatusLoteEnum.CANCELADO:
        if (this.importacaoType === EImportacaoType.CARGA) {
          page = "carga-finalizada";
        } else {
          page = "importacao-finalizada";
        }
        break;
      default:
        if (this.importacaoType === EImportacaoType.CARGA) {
          page = "carga-finalizada";
        } else {
          page = "importacao-finalizada";
        }
        break;
    }

    this.router.navigate([page], {
      relativeTo: this.activatedRoute.parent,
      queryParams: { loteId: lote.id },
    });
  }

  showStatusEmitter(show: boolean) {
    this.showStatus = show;
  }

  showCancelButton(row) {
    return (
      row.status === EStatusLoteEnum.ABERTO ||
      row.status === EStatusLoteEnum.CRIADO ||
      row.status === EStatusLoteEnum.AGUARDANDO_PROCESSAMENTO
    );
  }
}
